import PDFDict from 'PDFLib/core/objects/PDFDict';
import PDFName from 'PDFLib/core/objects/PDFName';
import PDFRef from 'PDFLib/core/objects/PDFRef';
import PDFString from 'PDFLib/core/objects/PDFString';
import PDFHexString from 'PDFLib/core/objects/PDFHexString';
import PDFContext from 'PDFLib/core/PDFContext';
import BorderStyle from 'PDFLib/core/annotation/BorderStyle';
import PDFAnnotation from 'PDFLib/core/annotation/PDFAnnotation';
import AppearanceCharacteristics from 'PDFLib/core/annotation/AppearanceCharacteristics';
import PDFNumber from "../objects/PDFNumber";

class PDFWidgetAnnotation extends PDFAnnotation {
  static fromDict = (dict: PDFDict): PDFWidgetAnnotation =>
    new PDFWidgetAnnotation(dict);

  static create = (context: PDFContext, parent: PDFRef) => {
    const dict = context.obj({
      Type: 'Annot',
      Subtype: 'Widget',
      Rect: [0, 0, 0, 0],
      Parent: parent,
    });
    return new PDFWidgetAnnotation(dict);
  };

  MK(): PDFDict | undefined {
    const MK = this.dict.lookup(PDFName.of('MK'));
    if (MK instanceof PDFDict) return MK;
    return undefined;
  }

  Q(): PDFNumber | undefined {
    const Q = this.dict.lookup(PDFName.of('Q'));
    if (Q instanceof PDFNumber) return Q;
    return undefined;
  }

  BS(): PDFDict | undefined {
    const BS = this.dict.lookup(PDFName.of('BS'));
    if (BS instanceof PDFDict) return BS;
    return undefined;
  }

  DA(): PDFString | PDFHexString | undefined {
    const da = this.dict.lookup(PDFName.of('DA'));
    if (da instanceof PDFString || da instanceof PDFHexString) return da;
    return undefined;
  }

  setDefaultAppearance(appearance: string) {
    this.dict.set(PDFName.of('DA'), PDFString.of(appearance));
  }

  getDefaultAppearance(): string | undefined {
    return this.DA()?.asString() ?? '';
  }

  getAppearanceCharacteristics(): AppearanceCharacteristics | undefined {
    const MK = this.MK();
    if (MK) return AppearanceCharacteristics.fromDict(MK);
    return undefined;
  }

  getOrCreateAppearanceCharacteristics(): AppearanceCharacteristics {
    const MK = this.MK();
    if (MK) return AppearanceCharacteristics.fromDict(MK);

    const ac = AppearanceCharacteristics.fromDict(this.dict.context.obj({}));
    this.dict.set(PDFName.of('MK'), ac.dict);
    return ac;
  }

  getBorderStyle(): BorderStyle | undefined {
    const BS = this.BS();
    if (BS) return BorderStyle.fromDict(BS);
    return undefined;
  }

  getOrCreateBorderStyle(): BorderStyle {
    const BS = this.BS();
    if (BS) return BorderStyle.fromDict(BS);

    const bs = BorderStyle.fromDict(this.dict.context.obj({}));
    this.dict.set(PDFName.of('BS'), bs.dict);
    return bs;
  }

  getOnValue(): PDFName | undefined {
    const normal = this.getAppearances()?.normal;

    if (normal instanceof PDFDict) {
      const keys = normal.keys();
      for (let idx = 0, len = keys.length; idx < len; idx++) {
        const key = keys[idx];
        if (key !== PDFName.of('Off')) return key;
      }
    }

    return undefined;
  }

  getAlingment(): number | string {
    return this.Q()?.asNumber()??'';
  }

  setAlingment(alignment: any) {

    if(alignment=='')
    {
      this.dict.delete(PDFName.of('Q'));
      return;
    }

    alignment=parseFloat(alignment);
    if(isNaN(alignment)||alignment<0||alignment>2)
      return;

    const q = this.dict.context.obj(alignment);
    this.dict.set(PDFName.of('Q'), q);
  }
}

export default PDFWidgetAnnotation;
